var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _g, _g2, _path193, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 382,
    height: 194,
    viewBox: "0 0 382 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10512_1016)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 382,
    height: 194,
    rx: 24,
    fill: "#0E917A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.613 139.627C116.736 143.733 117.31 196.882 111 227.046V255.682L475.807 270L482.116 63.2459C494.162 0.245981 379.824 -34.0113 336.423 6.54598C291.683 48.355 299.139 134.472 197.613 139.627Z",
    fill: "#628EB3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M217.81 164.537C218.425 159.637 222.135 151.571 223.579 141.289C225.197 129.784 222.099 116.129 222.099 116.129C222.099 116.129 216.31 130.19 214.519 141.289C212.913 151.245 214.459 160.668 213.887 164.677L217.81 164.537Z",
    fill: "url(#paint0_linear_10512_1016)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M208.142 165.022C207.597 160.616 204.412 153.41 203.177 144.321C201.812 134.274 204.42 122.51 204.42 122.51C204.42 122.51 209.318 134.624 210.876 144.321C212.293 153.123 211.01 161.539 211.52 165.15L208.142 165.022Z",
    fill: "url(#paint1_linear_10512_1016)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M217.81 164.537C218.425 159.637 222.135 151.571 223.579 141.289C225.197 129.784 222.099 116.129 222.099 116.129C222.099 116.129 216.31 130.19 214.519 141.289C212.913 151.245 214.459 160.668 213.887 164.677L217.81 164.537Z",
    fill: "#246266"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M208.142 165.022C207.597 160.616 204.412 153.41 203.177 144.321C201.812 134.274 204.42 122.51 204.42 122.51C204.42 122.51 209.318 134.624 210.876 144.321C212.293 153.123 211.01 161.539 211.52 165.15L208.142 165.022Z",
    fill: "#246266"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M214.704 164.677C214.704 159.131 217.415 149.908 217.589 137.985C217.786 124.417 212.814 108 212.814 108C212.814 108 208.717 124.899 208.37 137.985C208.062 149.533 210.856 160.298 210.801 164.832L214.704 164.673V164.677Z",
    fill: "url(#paint2_linear_10512_1016)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M220.762 164.689C221.839 159.502 226.286 150.927 228.733 139.927C231.491 127.527 229.775 112.682 229.775 112.682C229.775 112.682 222.604 127.965 219.743 139.927C217.198 150.58 217.83 160.597 216.886 164.836L220.762 164.689Z",
    fill: "url(#paint3_linear_10512_1016)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M204.669 164.705C203.663 160.151 199.551 152.694 197.341 143.259C194.89 132.789 196.548 120.488 196.548 120.488C196.548 120.488 203.004 133.156 205.616 143.259C207.98 152.396 207.408 161.11 208.296 164.836L204.669 164.705Z",
    fill: "url(#paint4_linear_10512_1016)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M196.548 120.488C196.548 120.488 197.436 134.211 200.143 143.773C202.167 150.927 206.445 160.593 207.637 164.769L204.669 164.705C203.663 160.151 199.551 152.694 197.341 143.259C194.89 132.789 196.548 120.488 196.548 120.488Z",
    fill: "#246266"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M213.887 164.677C213.615 160.895 211.211 149.131 211.389 137.26C211.614 122.3 212.814 108.004 212.814 108.004C212.814 108.004 208.717 124.903 208.37 137.989C208.062 149.537 210.856 160.302 210.801 164.836L213.887 164.677Z",
    fill: "#246266"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M219.704 164.689C220.75 159.502 220.347 150.788 222.439 139.768C224.799 127.348 229.775 112.678 229.775 112.678C229.775 112.678 222.604 127.961 219.743 139.923C217.198 150.577 217.83 160.593 216.886 164.832L219.7 164.685L219.704 164.689Z",
    fill: "#246266"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M199.519 129.959C198.576 130.15 199.488 135.918 200.948 141.289C202.27 146.141 204.037 150.668 205.3 150.445C207.956 149.971 201.082 129.644 199.519 129.959Z",
    fill: "#47B3AA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M228.729 123.023C227.81 122.745 225.805 130.042 224.59 135.472C223.493 140.38 222.881 147.164 224.1 147.562C225.268 147.948 227.324 142.383 228.338 136.809C229.546 130.169 229.558 123.274 228.729 123.023Z",
    fill: "#47B3AA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M213.706 118.219C212.329 118.247 212.06 144.688 214.981 144.772C217.901 144.855 215.431 118.187 213.706 118.219Z",
    fill: "#47B3AA"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M206.551 190.287H218.603C221.867 183.877 224.522 175.41 226.543 163.781H198.608C200.778 176.186 203.414 184.486 206.548 190.287H206.551Z",
    fill: "url(#paint5_linear_10512_1016)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M198.955 165.7C198.837 165.071 198.722 164.434 198.608 163.781H226.543C226.428 164.43 226.314 165.071 226.2 165.7H198.955Z",
    fill: "#D8CCFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M208.919 163.781C208.919 163.781 209.87 179.896 212.656 190.287H206.548C203.414 184.486 200.778 176.19 198.608 163.781H208.919Z",
    fill: "#60578F"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M362.344 80.5794L296.238 147.268L298.348 149.396L364.454 82.7078L362.344 80.5794Z",
    fill: "url(#paint6_linear_10512_1016)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M296.818 146.682L359.277 83.6723L362.346 80.5762L363.148 81.3849L364.457 82.7057L361.189 86.0029C360.809 85.5052 360.42 85.0218 360.022 84.5385L297.686 147.424C298.165 147.826 298.644 148.218 299.137 148.601L298.355 149.391L296.249 147.261L296.827 146.677L296.818 146.682Z",
    fill: "#9E4435"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M324.572 180.998H329.961V158.416H324.572V180.998Z",
    fill: "url(#paint7_linear_10512_1016)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M327.267 152.764C349.648 152.764 367.792 134.46 367.792 111.882C367.792 89.3035 349.648 71 327.267 71C304.886 71 286.742 89.3035 286.742 111.882C286.742 134.46 304.886 152.764 327.267 152.764Z",
    fill: "url(#paint8_linear_10512_1016)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M331.513 124.065C333.951 122.496 337.362 122.611 339.914 120.979C341.223 120.141 342.456 118.993 343.647 118.045C344.501 117.366 345.364 116.04 346.365 115.346C347.727 114.404 348.471 115.203 349.966 114.911C351.374 114.638 352.024 113.71 353.699 113.868C353.329 114.241 353.637 113.738 353.528 114.461C354.809 114.786 356.488 116.911 356.616 118.04C356.725 119.007 355.848 120.041 355.98 121.141C356.113 122.223 356.782 122.907 356.815 124.056C356.882 126.434 355.596 127.779 354.159 129.339C353.02 130.578 352.366 132.272 350.995 133.335C350.127 134.009 349.017 134.23 348.101 134.833C344.695 137.077 344.629 142.47 342.252 145.399C341.55 146.265 335.569 151.558 334.051 150.002C333.268 149.198 334.795 148.878 335.004 148.17C335.274 147.251 334.942 146.892 334.881 146.074C334.729 144.155 333.581 142.657 333.377 140.848C333.258 139.762 334.264 138.714 333.439 137.742C332.964 137.187 332.125 137.589 331.522 137.307C329.269 136.249 329.625 134.66 330.014 132.473C330.555 129.435 328.344 126.109 331.518 124.065H331.513Z",
    fill: "url(#paint9_radial_10512_1016)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M366.094 112.778C365.093 113.184 364.187 112.567 363.229 113.05C362.512 113.409 362.048 114.323 361.421 114.338C361.085 114.582 360.653 114.668 360.207 114.63C359.405 112.907 361.459 111.993 362.607 111.141C363.428 110.528 363.921 110.796 364.415 109.634C364.832 108.643 364.732 107.341 364.69 106.265C364.581 103.652 362.19 102.427 359.714 102.881C358.68 103.073 358.229 103.805 357.29 102.824C356.436 101.929 356.479 100.465 355.511 99.4693C353.556 97.4642 352.494 95.1911 349.947 93.8991C348.699 93.2674 347.394 92.6022 346.346 91.7696C344.624 90.4057 345.938 90.042 345.26 88.458C344.757 87.276 343.552 87.5871 342.499 87.3239C341.498 87.075 339.757 86.5199 339.188 85.5868C338.41 84.3043 339.159 83.6104 339.629 82.5097C339.857 81.9738 339.454 81.4665 340.037 81.0837C341.009 80.4472 341.133 81.6866 341.835 81.6914C342.508 81.6962 342.755 81.0741 343.31 81.0789C344.373 81.0885 344.449 81.8158 345.094 82.4858C346.46 83.9023 348.405 84.6058 350.397 84.3808C352.152 84.1846 353.258 83.6343 351.479 82.2896C350.615 81.6388 350.264 81.9881 350.065 80.763C350.018 80.4807 350.454 79.9304 350.255 79.3848C350.644 79.1982 351.085 79.1264 351.559 79.1456C361.251 86.4769 367.579 98.0815 367.792 111.194C367.308 111.931 366.744 112.514 366.099 112.778H366.094Z",
    fill: "url(#paint10_radial_10512_1016)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M295.252 92.9136C295.926 93.2725 296.296 94.4067 296.889 94.5885C297.316 94.7177 299.83 93.8181 300.485 93.6362C301.144 93.4544 302.325 93.2247 302.643 92.6217C303.274 91.4253 301.931 90.497 304.047 90.4922C304.806 90.4922 306.001 90.8655 306.884 90.9707C307.875 91.0904 308.71 91.3871 309.588 91.7555C310.342 92.0714 310.921 92.4781 311.675 92.4303C311.708 92.5786 311.76 92.7174 311.988 92.6983C313.226 92.8083 314.668 94.3636 315.18 95.359C315.612 96.1916 315.569 96.8999 316.153 97.7278C316.608 98.3738 317.211 98.8523 317.704 99.4457C319.137 101.173 319.511 102.676 319.293 104.896C319.132 106.543 320.057 108.452 319.53 109.878C319.137 110.945 318.074 111.309 317.453 112.161C316.921 112.893 316.869 113.888 316.248 114.577C314.867 116.113 312.932 115.582 311.2 115.754C310.551 115.821 309.863 116.319 309.108 116.061C308.302 115.783 307.975 114.706 306.945 114.515C306.039 114.348 305.722 114.927 305.029 115.013C304.298 115.099 303.625 114.726 302.913 114.817C300.883 115.07 301.893 117.855 300.836 119.368C300.352 120.061 299.588 120.492 299.166 121.339C298.578 122.521 298.701 123.483 298.431 124.708C298.265 125.474 297.207 126.306 297.216 126.895C297.23 127.718 298.117 127.728 298.393 128.383C298.81 129.369 298.412 130.881 297.999 131.795C297.425 133.059 297.216 133.757 296.917 135.121C296.789 135.71 296.433 137.155 295.817 137.662C290.148 130.628 286.752 121.66 286.752 111.888C286.752 106.021 287.98 100.436 290.186 95.3925C291.519 93.4879 293.236 91.8369 295.262 92.9184L295.252 92.9136Z",
    fill: "url(#paint11_radial_10512_1016)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 72.1152C324.682 71.4308 326.48 72.1008 328.662 72.5506C329.653 72.7564 333.458 72.5267 333.591 73.9528C334.174 74.594 332.784 74.4361 332.424 74.3404C331.845 74.1873 331.394 74.0054 330.806 74.2782C330.768 75.0199 331.076 75.8669 331.408 76.4651C331.888 77.3265 332.661 77.6376 332.405 78.8578C332.22 79.724 331.029 80.0494 330.151 79.7623C329.445 79.5326 328.871 78.6138 328.301 78.1257C327.642 77.561 326.949 77.2499 326.11 77.0872C325.009 76.8719 323.885 76.714 322.799 76.4029C321.452 76.0201 320.133 75.13 318.733 75.0438C318.103 73.7661 321.746 72.3496 322.5 72.1104V72.1152Z",
    fill: "url(#paint12_radial_10512_1016)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M314.896 89.6781C315.057 90.8122 314.72 91.4535 313.458 91.6162C312.486 91.7406 311.419 91.1663 310.584 90.6399C309.901 90.2093 309.773 89.9221 309.497 89.2617C309.161 88.4482 308.549 88.5248 308.032 87.9505C307.51 87.3667 307.685 86.8355 306.694 86.4623C305.883 86.156 305.133 86.2373 304.36 86.5819C302.956 87.2136 300.352 88.654 298.881 87.405C298.089 86.735 298.407 85.7684 298.929 84.974C300.039 83.2847 301.784 81.2988 303.796 80.7676C304.934 80.4661 306.319 80.5475 307.382 81.0499C308.259 81.4663 308.544 82.4616 309.412 82.921C310.399 83.4426 311.395 83.1172 310.721 84.5433C310.531 84.9453 310.237 85.1319 310.266 85.7014C310.285 86.1368 310.309 86.5005 310.731 86.7207C311.879 87.3141 313.454 86.3043 314.611 87.07V87.0796C315.09 87.3236 315.043 87.7878 314.995 88.2424C314.934 88.8119 314.81 89.0655 314.896 89.6781Z",
    fill: "url(#paint13_radial_10512_1016)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M327.267 71C335.953 71 343.998 73.7564 350.592 78.4461C345.649 75.8285 340.023 74.345 334.055 74.345C314.393 74.345 298.454 90.4241 298.454 110.26C298.454 130.095 314.393 146.174 334.055 146.174C345.99 146.174 356.55 140.25 363.011 131.162C356.18 144.016 342.736 152.764 327.267 152.764C304.887 152.764 286.742 134.46 286.742 111.882C286.742 89.3043 304.887 71 327.267 71Z",
    fill: "#26426A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M326.646 158.41V158.511C326.855 158.511 327.059 158.511 327.267 158.511C328.173 158.511 329.07 158.482 329.962 158.429V163.454C329.07 163.502 328.169 163.531 327.267 163.531C327.059 163.531 326.855 163.531 326.646 163.531V180.997H324.573V163.464V158.439V158.415H326.646V158.41Z",
    fill: "#9E4435"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M293.478 188.731H361.056V184.549C338.254 177.859 315.731 177.859 293.478 184.549V188.731Z",
    fill: "url(#paint14_linear_10512_1016)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M327.267 161.549C354.415 161.549 376.502 139.268 376.502 111.886C376.502 98.6019 371.369 86.1167 362.048 76.7324L358.537 80.288C366.915 88.7247 371.53 99.9466 371.53 111.886C371.53 136.503 351.678 156.534 327.272 156.534C315.437 156.534 304.313 151.878 295.95 143.427L292.425 146.973C301.728 156.376 314.104 161.554 327.267 161.554V161.549Z",
    fill: "url(#paint15_linear_10512_1016)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M327.006 179.533C322.571 180.883 320.114 184.553 320.114 184.553H361.056V188.736H293.478V184.553C304.583 181.213 315.764 179.538 327.006 179.533Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M371.734 110.213C371.734 112.385 371.577 114.525 371.279 116.616C371.44 115.06 371.525 113.481 371.525 111.883C371.525 99.9385 366.914 88.7167 358.532 80.2847L359.457 79.3516C367.379 87.6974 371.734 98.6129 371.734 110.213Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M293.364 146.022C302.581 154.966 314.654 159.876 327.476 159.876C352.252 159.876 372.816 141.313 376.217 117.252C373.556 142.122 352.617 161.546 327.272 161.546C314.104 161.546 301.732 156.368 292.43 146.965L293.369 146.017L293.364 146.022Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M332.959 81.1645C318.871 92.994 349.937 109.245 357.56 103.168C369.386 93.7454 345.25 70.8471 332.959 81.1645Z",
    fill: "#FFF7E6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M357.574 109.418C346.522 108.657 350.416 124.014 355.719 124.224C363.95 124.55 366.236 110.016 357.574 109.418Z",
    fill: "#FFF7E6"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M184 193.952L275.13 193.685L229.434 147.85L184 193.948V193.952ZM253.988 185.195L205.09 185.339L229.468 160.603L253.988 185.195Z",
    fill: "url(#paint16_linear_10512_1016)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M225.384 155.013L225.583 154.812L224.07 153.295L223.87 153.491L225.384 155.013Z",
    fill: "#463332"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M224.155 156.263L224.349 156.062L222.836 154.545L222.642 154.741L224.155 156.263Z",
    fill: "#463332"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M221.347 159.105L221.542 158.908L220.028 157.387L219.834 157.588L221.347 159.105Z",
    fill: "#463332"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M220.113 160.353L220.312 160.157L218.799 158.635L218.6 158.836L220.113 160.353Z",
    fill: "#463332"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M217.305 163.196L217.504 162.999L215.991 161.482L215.797 161.679L217.305 163.196Z",
    fill: "#463332"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M216.076 164.446L216.271 164.249L214.758 162.732L214.563 162.929L216.076 164.446Z",
    fill: "#463332"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M213.268 167.292L213.463 167.091L211.954 165.574L211.755 165.77L213.268 167.292Z",
    fill: "#463332"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M212.035 168.542L212.234 168.341L210.721 166.824L210.522 167.02L212.035 168.542Z",
    fill: "#463332"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M209.231 171.384L209.426 171.188L207.912 169.666L207.718 169.867L209.231 171.384Z",
    fill: "#463332"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M207.998 172.632L208.192 172.431L206.679 170.914L206.485 171.11L207.998 172.632Z",
    fill: "#463332"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M205.19 175.476L205.389 175.28L203.876 173.758L203.677 173.959L205.19 175.476Z",
    fill: "#463332"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M203.957 176.724L204.156 176.528L202.643 175.006L202.443 175.207L203.957 176.724Z",
    fill: "#463332"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M201.12 179.605L201.314 179.404L199.801 177.887L199.606 178.083L201.12 179.605Z",
    fill: "#463332"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M199.887 180.855L200.081 180.654L198.568 179.137L198.373 179.333L199.887 180.855Z",
    fill: "#463332"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M197.064 183.711L197.258 183.515L195.745 181.998L195.55 182.194L197.064 183.711Z",
    fill: "#463332"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M195.831 184.96L196.026 184.764L194.512 183.242L194.318 183.443L195.831 184.96Z",
    fill: "#463332"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M192.942 187.888L193.137 187.692L191.623 186.17L191.429 186.371L192.942 187.888Z",
    fill: "#463332"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M191.709 189.138L191.903 188.942L190.395 187.42L190.195 187.621L191.709 189.138Z",
    fill: "#463332"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M228.035 154.893L228.301 154.625L225.516 151.83L225.25 152.098L228.035 154.893Z",
    fill: "#463332"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M223.979 159.003L224.245 158.735L221.46 155.936L221.195 156.208L223.979 159.003Z",
    fill: "#463332"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M219.924 163.114L220.189 162.846L217.405 160.047L217.139 160.32L219.924 163.114Z",
    fill: "#463332"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M215.868 167.226L216.134 166.958L213.349 164.158L213.083 164.431L215.868 167.226Z",
    fill: "#463332"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M211.812 171.335L212.078 171.067L209.293 168.268L209.027 168.536L211.812 171.335Z",
    fill: "#463332"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M207.756 175.446L208.022 175.178L205.237 172.379L204.971 172.647L207.756 175.446Z",
    fill: "#463332"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M203.7 179.558L203.966 179.285L201.177 176.49L200.911 176.758L203.7 179.558Z",
    fill: "#463332"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M199.644 183.667L199.91 183.394L197.121 180.6L196.855 180.868L199.644 183.667Z",
    fill: "#463332"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M195.589 187.774L195.854 187.506L193.065 184.711L192.8 184.979L195.589 187.774Z",
    fill: "#463332"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M191.528 191.885L191.794 191.617L189.009 188.822L188.748 189.09L191.528 191.885Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M224.297 193.838C224.297 193.46 224.297 192.269 224.287 190.211H226.598L226.583 185.277L253.987 185.196L233.153 164.298C233.092 164.063 233.011 163.838 233.006 163.585L232.973 151.841C232.973 151.712 233.03 151.607 233.044 151.482L275.125 193.69L224.292 193.838H224.297Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M254.5 184.698L253.494 184.703L229.477 160.613L229.98 160.105L254.5 184.698Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M229.43 147.855L229.79 148.214L185.2 193.456L274.632 193.193L275.125 193.69L184 193.954L229.43 147.855Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M205.044 186.04L232.177 185.959L232.175 185.303L205.042 185.385L205.044 186.04Z",
    fill: "#FFF7E6"
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M370.889 191.634L372.069 191.324L371.25 188.147L370.07 188.457L370.889 191.634Z",
    fill: "url(#paint17_linear_10512_1016)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M370.885 191.64L371.486 191.482L370.667 188.305L370.066 188.463L370.885 191.64Z",
    fill: "#463332"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M367.574 193.58L375.78 193.556C376.435 193.556 376.966 193.015 376.966 192.355C376.966 191.694 376.43 191.158 375.775 191.158L367.569 191.182C366.914 191.182 366.383 191.723 366.383 192.383C366.383 193.044 366.919 193.58 367.574 193.58Z",
    fill: "url(#paint18_linear_10512_1016)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M370.729 188.564C371.853 188.267 372.526 187.109 372.232 185.975L371.782 184.223C371.488 183.089 370.34 182.41 369.215 182.706C368.091 183.003 367.418 184.161 367.712 185.295L368.162 187.047C368.456 188.181 369.604 188.86 370.729 188.564Z",
    fill: "url(#paint19_linear_10512_1016)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M369.22 182.706C369.486 182.634 369.751 182.629 370.012 182.663C370.306 182.84 370.629 182.969 370.966 183.065C371.35 183.342 371.658 183.73 371.786 184.227L372.199 185.821C371.711 186.352 371.108 186.788 370.363 186.984C370.017 187.075 369.671 187.099 369.325 187.094C369.794 187.864 370.691 188.29 371.601 188.061C371.355 188.285 371.075 188.477 370.729 188.568C369.604 188.865 368.456 188.18 368.162 187.051L367.712 185.299C367.418 184.165 368.091 183.007 369.215 182.71L369.22 182.706Z",
    fill: "#463332"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M370.131 186.252C372.223 185.702 373.475 183.549 372.93 181.443L351.65 98.8848L344.079 100.871L365.359 183.429C365.904 185.539 368.039 186.803 370.126 186.252H370.131Z",
    fill: "url(#paint20_linear_10512_1016)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M344.084 100.871L351.654 98.8848L352.461 102.014C351.621 103.469 350.383 104.642 348.903 105.407L368.015 179.548C368.561 181.658 370.695 182.922 372.783 182.371C372.877 182.348 372.963 182.3 373.058 182.271C373.134 184.089 371.952 185.779 370.136 186.252C368.044 186.803 365.909 185.535 365.368 183.429L345.502 106.364L344.088 100.871H344.084Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M367.564 191.185L370.842 191.176C370.187 191.176 369.656 191.717 369.656 192.377C369.656 193.037 370.192 193.573 370.847 193.568L367.569 193.578C366.914 193.578 366.378 193.047 366.378 192.386C366.378 191.726 366.905 191.185 367.56 191.185H367.564Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M367.569 192.766L375.776 192.742C376.288 192.742 376.715 192.407 376.881 191.947C376.928 192.076 376.961 192.21 376.961 192.354C376.961 193.014 376.435 193.555 375.776 193.555L367.569 193.579C366.914 193.579 366.378 193.048 366.378 192.388C366.378 192.244 366.412 192.11 366.459 191.981C366.625 192.44 367.052 192.77 367.569 192.77V192.766Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M376.16 191.698C376.307 191.243 373.522 191.353 373.423 191.592C373.271 191.966 376.032 192.095 376.16 191.698Z",
    fill: "#FFF7E6"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M373.072 191.697C373.124 191.367 372.156 191.449 372.123 191.621C372.071 191.889 373.029 191.985 373.072 191.697Z",
    fill: "#FFF7E6"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M316.476 190.153C318.549 190.751 320.707 189.536 321.3 187.445L322.215 184.215C322.808 182.123 321.604 179.946 319.531 179.348C317.458 178.75 315.299 179.965 314.706 182.056L313.791 185.287C313.198 187.378 314.403 189.555 316.476 190.153Z",
    fill: "url(#paint21_linear_10512_1016)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M315.683 192.948C317.206 193.388 318.795 192.493 319.232 190.957L319.905 188.578C320.342 187.042 319.455 185.439 317.932 184.999C316.409 184.559 314.82 185.454 314.384 186.99L313.71 189.368C313.274 190.904 314.161 192.507 315.683 192.948Z",
    fill: "url(#paint22_linear_10512_1016)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M317.301 187.229C319.378 187.827 321.541 186.612 322.134 184.516L345.762 100.972L338.244 98.8086L314.616 182.353C314.023 184.449 315.228 186.631 317.305 187.229H317.301Z",
    fill: "url(#paint23_linear_10512_1016)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M314.611 182.353L337.371 101.881L338.239 98.8086L345.758 100.972L344.24 106.341C342.717 106.216 341.313 105.695 340.118 104.881L318.719 180.549C318.126 182.645 319.331 184.827 321.409 185.425C321.504 185.454 321.603 185.458 321.698 185.478C320.806 186.951 319.028 187.722 317.301 187.224C315.223 186.626 314.023 184.444 314.616 182.348L314.611 182.353Z",
    fill: "#9E4435"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M342.366 91.826L347.503 91.8117L347.47 80.2931C347.47 78.8623 346.313 77.7042 344.894 77.709C343.476 77.709 342.328 78.8766 342.333 80.3075L342.366 91.826Z",
    fill: "url(#paint24_linear_10512_1016)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M344.895 77.709C345.046 77.709 345.179 77.7712 345.326 77.7951C344.52 78.2354 343.955 79.068 343.96 80.0538L343.974 84.8967C344.287 84.8536 344.596 84.8106 344.918 84.8058C345.82 84.8058 346.669 84.9781 347.489 85.2317L347.508 91.5628V91.8117L342.371 91.826L342.352 85.246L342.338 80.3075C342.338 78.8766 343.481 77.7138 344.899 77.709H344.895Z",
    fill: "#463332"
  }))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M351.099 101.556C354.501 98.1253 354.501 92.5622 351.099 89.1311C347.698 85.6999 342.184 85.6999 338.783 89.1311C335.381 92.5622 335.381 98.1253 338.783 101.556C342.184 104.988 347.698 104.988 351.099 101.556Z",
    fill: "url(#paint25_linear_10512_1016)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M340.255 95.0993C340.265 97.8557 342.504 100.081 345.265 100.076C348.025 100.067 350.255 97.827 350.245 95.0706C350.236 92.3142 347.997 90.089 345.236 90.0938C342.475 90.1033 340.246 92.3429 340.255 95.0993Z",
    fill: "#9E4435"
  }))), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M348.255 98.687C350.085 96.8406 350.085 93.847 348.255 92.0005C346.425 90.1541 343.457 90.1541 341.627 92.0005C339.797 93.8469 339.797 96.8406 341.627 98.687C343.457 100.533 346.425 100.533 348.255 98.687Z",
    fill: "url(#paint26_linear_10512_1016)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M343.486 86.7051C340.047 87.6813 337.513 90.8397 337.523 94.6202C337.537 99.1663 341.199 102.837 345.706 102.827C349.453 102.818 352.57 100.243 353.518 96.7688C352.845 100.932 349.292 104.119 344.975 104.134C340.165 104.148 336.252 100.224 336.237 95.3715C336.223 91.012 339.368 87.4133 343.49 86.7099L343.486 86.7051Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M344.781 92.0265C343.026 93.51 346.911 95.5247 347.859 94.7638C349.33 93.5818 346.313 90.7344 344.781 92.0265Z",
    fill: "#FFF7E6"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M347.859 95.5442C346.479 95.4532 346.972 97.3674 347.632 97.3913C348.661 97.4296 348.941 95.6159 347.859 95.5442Z",
    fill: "#FFF7E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M345.212 78.3406C344.003 79.0202 346.038 80.5994 346.688 80.2548C347.698 79.7189 346.27 77.7473 345.212 78.3406Z",
    fill: "#FFF7E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M344.928 90.6152C344.985 90.6152 345.037 90.6296 345.094 90.6296C342.807 90.7253 340.986 92.6155 340.991 94.9461C340.995 97.334 342.921 99.2577 345.284 99.2529C347.651 99.2482 349.558 97.3053 349.553 94.9221C349.553 94.6829 349.52 94.4484 349.482 94.2187C349.567 94.5776 349.629 94.9461 349.629 95.3289C349.638 97.9417 347.542 100.062 344.956 100.071C342.366 100.081 340.265 97.9657 340.255 95.3576C340.246 92.7495 342.342 90.6248 344.928 90.6152Z",
    fill: "#463332"
  }))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M290.618 150.964L333.676 150.84L353.186 193.636L310.954 193.76L290.722 152.424C290.49 151.955 290.475 151.438 290.613 150.969L290.618 150.964Z",
    fill: "url(#paint27_linear_10512_1016)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M290.618 150.964L333.676 150.84L353.186 193.636L310.954 193.76L290.722 152.424C290.49 151.955 290.475 151.438 290.613 150.969L290.618 150.964Z",
    fill: "#60578F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M292.055 155.132L290.727 152.419C290.495 151.95 290.48 151.433 290.618 150.964L333.676 150.84L335.573 155.003L292.055 155.132Z",
    fill: "#60578F"
  }))), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M333.676 150.84L290.618 150.965C290.77 150.453 291.111 150.003 291.624 149.749L298.986 146.083C299.099 146.026 299.583 145.892 299.702 145.892C299.745 145.892 299.783 145.892 299.825 145.892L342.281 145.768L342.305 153.735L335.009 153.754L333.681 150.84H333.676Z",
    fill: "url(#paint28_linear_10512_1016)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M333.676 150.84L290.618 150.965C290.77 150.453 291.111 150.003 291.624 149.749L298.986 146.083C299.427 145.863 299.697 145.892 299.825 145.892L342.281 145.768L333.676 150.84Z",
    fill: "#60578F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M324.895 149.653L332.257 145.987C332.699 145.767 332.969 145.796 333.097 145.796L337.134 145.786C337.01 145.786 336.735 145.758 336.294 145.978L328.932 149.643C328.42 149.897 328.078 150.352 327.926 150.859L323.89 150.869C324.041 150.356 324.383 149.907 324.895 149.653Z",
    fill: "#60578F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M295.167 149.739L302.529 146.073C302.97 145.853 303.241 145.882 303.369 145.882L307.406 145.872C307.282 145.872 307.007 145.844 306.566 146.064L299.204 149.729C298.692 149.983 298.35 150.438 298.198 150.945L294.161 150.954C294.313 150.442 294.655 149.993 295.167 149.739Z",
    fill: "#60578F"
  }))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M354.581 191.401L361.488 187.96L362.095 189.195C363.418 188.535 364.097 188.2 364.097 188.2L343.865 146.863C343.381 145.877 342.195 145.47 341.218 145.959L333.856 149.624C332.879 150.112 332.476 151.309 332.96 152.294L353.191 193.631C353.191 193.631 353.874 193.291 355.188 192.636L354.581 191.401Z",
    fill: "url(#paint29_linear_10512_1016)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M343.051 150.26L361.504 187.959L354.597 191.4L336.144 153.701C335.837 153.074 336.091 152.318 336.712 152.009L341.374 149.686C341.995 149.377 342.744 149.633 343.051 150.26Z",
    fill: "#CEB6AA"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M343.018 150.206L336.11 153.646L354.582 191.384L361.49 187.943L343.018 150.206Z",
    fill: "#CEB6AA"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M341.28 149.557L336.65 151.863C336.019 152.174 335.763 152.945 336.076 153.576L354.586 191.396L361.493 187.955L342.983 150.136C342.675 149.499 341.911 149.241 341.285 149.557H341.28Z",
    fill: "#FFE6D6"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M342.077 152.834C341.764 152.198 341.005 151.94 340.374 152.251L336.394 154.232L336.071 153.571C335.763 152.935 336.019 152.169 336.645 151.858L341.275 149.552C341.906 149.241 342.665 149.499 342.973 150.131L361.483 187.95L359.695 188.84L342.072 152.83L342.077 152.834Z",
    fill: "#CEB6AA"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M338.984 152.826C338.984 152.826 339.942 154.889 341.384 157.98C342.859 161.057 344.828 165.153 346.796 169.255C348.827 173.322 350.857 177.395 352.38 180.443C353.94 183.477 354.979 185.496 354.979 185.496C354.979 185.496 354.021 183.434 352.579 180.342C351.104 177.265 349.135 173.169 347.166 169.068C345.136 165 343.106 160.933 341.583 157.88C340.022 154.846 338.984 152.826 338.984 152.826Z",
    fill: "#CEB6AA"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M353.561 178.453C353.561 178.453 353.803 179.08 354.192 180.004C354.581 180.927 355.15 182.138 355.724 183.344C356.326 184.54 356.929 185.732 357.422 186.608C357.911 187.483 358.262 188.057 358.262 188.057C358.262 188.057 358.024 187.431 357.631 186.507C357.242 185.583 356.673 184.373 356.094 183.167C355.491 181.97 354.889 180.779 354.396 179.908C353.907 179.032 353.556 178.458 353.556 178.458L353.561 178.453Z",
    fill: "#CEB6AA"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M339.335 157.186C339.335 157.186 340.056 158.76 341.133 161.124C342.224 163.483 343.728 166.598 345.236 169.719C346.773 172.824 348.31 175.925 349.501 178.232C350.705 180.534 351.507 182.07 351.507 182.07C351.507 182.07 350.786 180.495 349.709 178.131C348.618 175.772 347.114 172.657 345.606 169.537C344.069 166.431 342.532 163.33 341.337 161.023C340.132 158.722 339.33 157.186 339.33 157.186H339.335Z",
    fill: "#CEB6AA"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M327.348 162.948L327.315 151.927H329.255C329.25 149.812 329.246 148.73 329.246 148.73L240.098 148.989C238.552 148.989 237.3 150.262 237.304 151.827L237.338 163.57C237.338 165.13 238.599 166.394 240.151 166.389L329.298 166.13C329.298 166.13 329.298 165.044 329.288 162.943H327.348V162.948Z",
    fill: "url(#paint30_linear_10512_1016)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M327.348 162.948L243.902 163.192C242.921 163.192 242.124 162.397 242.124 161.407L242.105 153.97C242.105 152.98 242.892 152.176 243.874 152.176L327.319 151.932L327.353 162.952L327.348 162.948Z",
    fill: "#CEB6AA"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M327.324 151.917L282.697 152.051L282.729 163.072L327.357 162.938L327.324 151.917Z",
    fill: "#CEB6AA"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M327.324 151.917L282.697 152.051L282.729 163.072L327.357 162.938L327.324 151.917Z",
    fill: "#FFE6D6"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M284.935 158.866C284.935 158.866 287.136 158.928 290.437 159.014C293.739 159.086 298.141 159.101 302.543 159.11C306.945 159.077 311.347 159.038 314.649 158.947C317.951 158.837 320.152 158.766 320.152 158.766C320.152 158.766 317.951 158.703 314.649 158.617C311.347 158.545 306.945 158.531 302.543 158.521C298.141 158.555 293.739 158.598 290.437 158.684C287.136 158.794 284.935 158.866 284.935 158.866Z",
    fill: "#CEB6AA"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M310.37 156.181C310.37 156.181 311.309 156.262 312.723 156.339C314.137 156.416 316.015 156.439 317.898 156.454C319.782 156.43 321.66 156.396 323.074 156.31C324.487 156.234 325.427 156.138 325.427 156.138C325.427 156.138 324.487 156.047 323.074 155.98C321.66 155.904 319.782 155.88 317.898 155.865C316.015 155.889 314.137 155.927 312.723 156.009C311.314 156.095 310.37 156.181 310.37 156.181Z",
    fill: "#CEB6AA"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M290.656 161.134C290.656 161.134 292.093 161.215 294.251 161.287C296.41 161.364 299.284 161.383 302.159 161.392C305.034 161.364 307.908 161.325 310.062 161.239C312.215 161.163 313.653 161.062 313.653 161.062C313.653 161.062 312.215 160.971 310.057 160.904C307.899 160.828 305.024 160.808 302.149 160.799C299.275 160.828 296.4 160.866 294.247 160.952C292.093 161.038 290.656 161.129 290.656 161.129V161.134Z",
    fill: "#CEB6AA"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M327.32 151.921L282.692 152.055L282.699 154.557L327.327 154.424L327.32 151.921Z",
    fill: "#CEB6AA"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M240.098 148.993L280.813 148.873L280.865 166.273L240.151 166.393C238.604 166.393 237.342 165.134 237.338 163.574L237.304 151.83C237.304 150.27 238.552 148.997 240.098 148.993Z",
    fill: "url(#paint31_linear_10512_1016)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M240.098 148.993L280.457 148.873C278.911 148.873 277.658 150.146 277.663 151.711L277.696 163.454C277.696 165.014 278.958 166.278 280.509 166.273L240.151 166.393C238.604 166.393 237.342 165.134 237.338 163.574L237.304 151.83C237.304 150.27 238.552 148.997 240.098 148.993Z",
    fill: "#398191"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M268.152 163.483L268.119 151.74C268.119 150.18 269.366 148.907 270.913 148.902L273.669 148.893C272.122 148.893 270.87 150.166 270.875 151.73L270.908 163.474C270.908 165.034 272.17 166.297 273.721 166.292L270.965 166.302C269.418 166.302 268.157 165.043 268.152 163.483Z",
    fill: "#398191"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M241.868 163.561L241.834 151.818C241.834 150.258 243.082 148.985 244.628 148.98L247.384 148.971C245.838 148.971 244.586 150.244 244.59 151.808L244.624 163.552C244.624 165.112 245.886 166.375 247.437 166.371L244.681 166.38C243.134 166.38 241.872 165.122 241.868 163.561Z",
    fill: "#398191"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M277.697 163.072V163.455C277.701 165.015 278.958 166.279 280.51 166.274L240.151 166.393C238.604 166.393 237.342 165.135 237.338 163.575V163.192L277.697 163.072Z",
    fill: "#398191"
  }))), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M323.719 146.757L323.7 140H324.891C324.891 138.703 324.886 138.043 324.886 138.043L243.319 138.282C242.37 138.282 241.602 139.062 241.607 140.019L241.626 147.221C241.626 148.179 242.399 148.954 243.348 148.949L324.914 148.71C324.914 148.71 324.914 148.045 324.91 146.752H323.719V146.757Z",
    fill: "url(#paint32_linear_10512_1016)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M245.633 140.219L323.708 139.986L323.728 146.743L245.653 146.976C245.05 146.978 244.565 146.487 244.563 145.884L244.55 141.323C244.548 140.716 245.035 140.226 245.633 140.224L245.633 140.219Z",
    fill: "#CEB6AA"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M323.703 139.992L286.528 140.104L286.548 146.861L323.723 146.749L323.703 139.992Z",
    fill: "#CEB6AA"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M323.703 139.992L286.528 140.104L286.548 146.861L323.723 146.749L323.703 139.992Z",
    fill: "#FFE6D6"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M287.9 144.284C287.9 144.284 289.864 144.317 292.805 144.365C295.751 144.379 299.674 144.398 303.601 144.418C307.529 144.374 311.452 144.336 314.398 144.303C317.344 144.236 319.303 144.193 319.303 144.193C319.303 144.193 317.339 144.159 314.398 144.111C311.452 144.097 307.529 144.078 303.601 144.059C299.674 144.102 295.751 144.14 292.805 144.173C289.859 144.24 287.9 144.284 287.9 144.284Z",
    fill: "#CEB6AA"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M313.311 142.608C313.311 142.608 313.89 142.666 314.753 142.699C315.617 142.718 316.774 142.747 317.927 142.776C320.237 142.785 322.542 142.58 322.542 142.58C322.542 142.58 320.232 142.388 317.927 142.412C316.774 142.446 315.621 142.479 314.753 142.503C313.89 142.546 313.311 142.604 313.311 142.604V142.608Z",
    fill: "#CEB6AA"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M291.41 145.676C291.41 145.676 292.904 145.71 295.148 145.763C297.392 145.777 300.38 145.801 303.369 145.82C309.346 145.82 315.327 145.605 315.327 145.605C315.327 145.605 309.35 145.428 303.369 145.456C300.38 145.495 297.392 145.533 295.148 145.562C292.904 145.629 291.41 145.672 291.41 145.672V145.676Z",
    fill: "#CEB6AA"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M323.703 139.992L286.528 140.104L286.532 141.635L323.708 141.524L323.703 139.992Z",
    fill: "#CEB6AA"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M243.314 138.283L285.371 138.158L285.4 148.825L243.343 148.949C242.394 148.949 241.621 148.179 241.621 147.222L241.602 140.02C241.602 139.063 242.365 138.283 243.314 138.283Z",
    fill: "url(#paint33_linear_10512_1016)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M243.314 138.282L285.153 138.162C284.204 138.162 283.436 138.942 283.441 139.899L283.46 147.101C283.46 148.058 284.233 148.834 285.182 148.829L243.343 148.948C242.394 148.948 241.621 148.178 241.621 147.221L241.602 140.019C241.602 139.062 242.365 138.282 243.314 138.282Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M277.611 147.117L277.592 139.915C277.592 138.958 278.356 138.178 279.304 138.178H280.993C280.044 138.178 279.276 138.953 279.281 139.91L279.3 147.112C279.3 148.069 280.073 148.844 281.022 148.84H279.333C278.384 148.849 277.611 148.074 277.611 147.117Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M273.033 147.131L273.014 139.929C273.014 138.971 273.778 138.191 274.727 138.191H276.416C275.467 138.191 274.698 138.967 274.703 139.924L274.722 147.126C274.722 148.083 275.495 148.858 276.444 148.853H274.755C273.807 148.863 273.033 148.088 273.033 147.131Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M249.481 147.197L249.462 139.995C249.462 139.038 250.226 138.258 251.174 138.258H252.863C251.914 138.258 251.146 139.033 251.151 139.99L251.17 147.192C251.17 148.149 251.943 148.925 252.892 148.92H251.203C250.254 148.929 249.481 148.154 249.481 147.197Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M244.903 147.213L244.884 140.011C244.884 139.053 245.648 138.273 246.597 138.273H248.286C247.337 138.273 246.568 139.049 246.573 140.006L246.592 147.208C246.592 148.165 247.365 148.94 248.314 148.935H246.625C245.677 148.945 244.903 148.17 244.903 147.213Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M283.464 146.862V147.097C283.464 148.054 284.238 148.829 285.186 148.824L243.347 148.944C242.399 148.944 241.625 148.173 241.625 147.216V146.982L283.464 146.857V146.862Z",
    fill: "#9E4435"
  }))), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M230.929 190.191L230.872 169.963H228.561C228.552 167.456 228.552 166.168 228.552 166.168L334.762 165.857C336.607 165.853 338.106 167.355 338.111 169.217L338.173 190.306C338.177 192.168 336.688 193.68 334.843 193.685L228.633 193.996C228.633 193.996 228.633 192.699 228.623 190.196H230.933L230.929 190.191Z",
    fill: "url(#paint34_linear_10512_1016)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M333.167 189.895L233.75 190.193L233.691 169.965L333.107 169.667C334.274 169.664 335.226 170.618 335.229 171.795L335.276 187.754C335.28 188.932 334.334 189.892 333.167 189.895Z",
    fill: "#A0335D"
  }))), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M230.929 190.192L330.346 189.9C331.513 189.9 332.457 188.938 332.457 187.761L332.409 171.801C332.409 170.624 331.456 169.672 330.289 169.672L230.872 169.964L230.929 190.192Z",
    fill: "#FFE6D6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M228.557 169.973C228.548 167.456 228.548 166.174 228.548 166.174L282.744 166.016L282.824 193.843L228.628 194.001C228.628 194.001 228.628 192.704 228.619 190.201H230.929L230.872 169.968H228.562L228.557 169.973Z",
    fill: "#A0335D"
  }))), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M284.044 169.8L230.878 169.959L230.937 190.187L284.104 190.028L284.044 169.8Z",
    fill: "#CEB6AA"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M284.044 169.8L230.878 169.959L230.937 190.187L284.104 190.028L284.044 169.8Z",
    fill: "#CEB6AA"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M282.241 169.815L330.289 169.676C331.456 169.676 332.405 170.623 332.409 171.805L332.419 174.83C332.419 173.652 331.465 172.7 330.298 172.7L282.25 172.839L282.241 169.815Z",
    fill: "#CEB6AA"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M328.833 175.38C328.833 175.38 327.429 175.251 325.327 175.16C324.274 175.126 323.05 175.055 321.736 175.045C320.422 175.031 319.018 175.016 317.619 175.002C316.215 175.026 314.816 175.045 313.502 175.069C312.188 175.088 310.959 175.169 309.911 175.208C307.809 175.313 306.405 175.452 306.405 175.452C306.405 175.452 307.809 175.581 309.911 175.677C310.964 175.705 312.188 175.782 313.502 175.792C314.816 175.806 316.22 175.82 317.619 175.835C319.023 175.811 320.422 175.787 321.736 175.768C323.05 175.748 324.279 175.667 325.327 175.629C327.429 175.524 328.833 175.385 328.833 175.385V175.38Z",
    fill: "#CEB6AA"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M322.187 186.315C322.187 186.315 320.133 186.2 317.049 186.1C315.508 186.066 313.71 186.028 311.784 185.989C309.858 185.975 307.804 185.966 305.75 185.951C303.696 185.975 301.642 185.999 299.716 186.023C297.79 186.042 295.992 186.128 294.451 186.167C291.367 186.286 289.313 186.415 289.313 186.415C289.313 186.415 291.367 186.53 294.451 186.635C295.992 186.664 297.79 186.736 299.716 186.746C301.642 186.755 303.696 186.769 305.75 186.784C307.804 186.76 309.858 186.736 311.784 186.712C313.71 186.659 315.508 186.612 317.049 186.568C320.133 186.449 322.187 186.32 322.187 186.32V186.315Z",
    fill: "#CEB6AA"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M325.512 179.157C325.512 179.157 323.458 179.042 320.374 178.941C318.833 178.908 317.035 178.87 315.109 178.831C313.183 178.817 311.129 178.807 309.075 178.793C307.021 178.817 304.967 178.841 303.041 178.865C301.115 178.884 299.317 178.97 297.776 179.008C294.692 179.128 292.638 179.257 292.638 179.257C292.638 179.257 294.692 179.372 297.776 179.477C299.317 179.506 301.115 179.578 303.041 179.587C304.967 179.597 307.021 179.611 309.075 179.626C311.129 179.602 313.183 179.578 315.109 179.554C317.035 179.501 318.833 179.453 320.374 179.41C323.458 179.291 325.512 179.161 325.512 179.161V179.157Z",
    fill: "#CEB6AA"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M281.425 183.645C281.425 183.645 278.802 183.501 274.869 183.401C272.9 183.363 270.609 183.324 268.152 183.277C265.695 183.262 263.072 183.253 260.448 183.238C257.825 183.267 255.207 183.296 252.745 183.324C250.288 183.348 247.992 183.444 246.028 183.487C242.095 183.612 239.472 183.769 239.472 183.769C239.472 183.769 242.095 183.913 246.028 184.014C247.996 184.047 250.288 184.128 252.745 184.138C255.202 184.152 257.825 184.162 260.448 184.176C263.072 184.148 265.69 184.119 268.152 184.09C270.609 184.033 272.905 183.975 274.869 183.927C278.802 183.803 281.425 183.645 281.425 183.645Z",
    fill: "#B29B93"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M251.089 174.916C251.089 174.916 249.97 174.821 248.286 174.754C246.602 174.677 244.363 174.653 242.119 174.639C239.875 174.667 237.636 174.701 235.952 174.792C234.273 174.868 233.149 174.974 233.149 174.974C233.149 174.974 234.268 175.069 235.952 175.136C237.636 175.213 239.875 175.237 242.119 175.251C244.363 175.222 246.602 175.189 248.286 175.098C249.965 175.022 251.089 174.916 251.089 174.916Z",
    fill: "#B29B93"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M273.052 187.182C273.052 187.182 271.34 187.067 268.769 186.981C266.198 186.885 262.773 186.856 259.353 186.842C255.928 186.875 252.503 186.923 249.937 187.033C247.37 187.134 245.658 187.258 245.658 187.258C245.658 187.258 247.37 187.373 249.941 187.459C252.512 187.555 255.937 187.579 259.357 187.598C262.782 187.56 266.207 187.517 268.774 187.406C271.34 187.306 273.052 187.182 273.052 187.182Z",
    fill: "#B29B93"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M272.241 178.447C272.241 178.447 270.529 178.332 267.958 178.246C265.387 178.15 261.962 178.122 258.542 178.107C255.117 178.141 251.692 178.189 249.126 178.299C246.559 178.399 244.847 178.524 244.847 178.524C244.847 178.524 246.559 178.639 249.13 178.725C251.701 178.82 255.126 178.844 258.547 178.864C261.971 178.825 265.396 178.782 267.963 178.672C270.529 178.572 272.241 178.447 272.241 178.447Z",
    fill: "#B29B93"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M284.044 169.8L230.878 169.959L230.886 172.94L284.053 172.781L284.044 169.8Z",
    fill: "#B29B93"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M319.805 172.929C318.444 176.116 318.008 185.328 317.946 190.018H341.28C341.318 185.467 340.972 175.958 339.529 172.532C337.504 167.708 332.381 164.674 332.381 163.512C332.381 162.349 336.484 159.583 338.733 155.415C340.592 151.974 341.247 145.217 341.285 140.082H317.951C317.913 145.26 318.558 152.007 320.251 155.529C322.163 159.501 326.85 162.133 326.85 163.516C326.85 164.899 321.874 168.101 319.805 172.929ZM319.288 188.692C319.426 182.754 320.005 175.824 321.015 173.456C322.12 170.862 324.231 168.689 325.768 167.105C327.262 165.56 328.168 164.631 328.168 163.516C328.168 162.325 327.163 161.382 325.635 159.961C324.189 158.616 322.391 156.936 321.437 154.95C320.014 151.993 319.345 146.25 319.274 141.412H339.947C339.814 146.212 339.14 151.897 337.58 154.783C336.413 156.946 334.705 158.707 333.334 160.123C331.921 161.583 331.072 162.464 331.072 163.516C331.072 164.569 331.869 165.292 333.315 166.665C334.952 168.22 337.196 170.35 338.329 173.049C339.501 175.844 339.942 183.615 339.975 188.692H319.298H319.288Z",
    fill: "url(#paint35_linear_10512_1016)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M339.966 188.694C339.933 183.612 339.491 175.84 338.32 173.051C337.186 170.352 334.947 168.222 333.306 166.667C331.859 165.293 331.062 164.537 331.062 163.518C331.062 162.499 331.916 161.585 333.325 160.125C334.696 158.709 336.403 156.948 337.57 154.785C339.131 151.894 339.809 146.214 339.937 141.414H319.265C319.336 146.252 320.005 151.995 321.428 154.952C322.381 156.938 324.179 158.618 325.626 159.967C327.153 161.388 328.159 162.331 328.159 163.523C328.159 164.714 327.253 165.571 325.759 167.112C324.222 168.696 322.111 170.868 321.006 173.462C319.995 175.831 319.416 182.76 319.279 188.699H339.956L339.966 188.694Z",
    fill: "url(#paint36_linear_10512_1016)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M317.846 193.996H341.384C341.845 193.996 342.219 193.619 342.219 193.154V189.531C342.219 189.066 341.845 188.689 341.384 188.689H317.846C317.385 188.689 317.012 189.066 317.012 189.531V193.154C317.012 193.619 317.385 193.996 317.846 193.996Z",
    fill: "url(#paint37_linear_10512_1016)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M317.846 141.441H341.384C341.845 141.441 342.219 141.064 342.219 140.599V136.977C342.219 136.511 341.845 136.134 341.384 136.134H317.846C317.385 136.134 317.012 136.511 317.012 136.977V140.599C317.012 141.064 317.385 141.441 317.846 141.441Z",
    fill: "url(#paint38_linear_10512_1016)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M317.808 188.693H326.916V189.636C326.916 190.124 327.271 190.517 327.713 190.517H342.219V193.115C342.219 193.603 341.863 193.996 341.422 193.996H317.808C317.367 193.996 317.011 193.598 317.011 193.115V189.574C317.011 189.086 317.367 188.693 317.808 188.693Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M317.808 136.135H341.422C341.863 136.135 342.219 136.532 342.219 137.015V139.561H327.713C327.271 139.561 326.916 139.958 326.916 140.442V141.437H317.808C317.367 141.437 317.011 141.04 317.011 140.557V137.015C317.011 136.527 317.367 136.135 317.808 136.135Z",
    fill: "#463332"
  }))), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M316.438 193.996H342.793C343.139 193.996 343.419 193.713 343.419 193.364V191.914C343.419 191.566 343.139 191.283 342.793 191.283H316.438C316.092 191.283 315.811 191.566 315.811 191.914V193.364C315.811 193.713 316.092 193.996 316.438 193.996Z",
    fill: "url(#paint39_linear_10512_1016)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M316.409 191.287H326.314C325.982 191.287 325.716 191.584 325.716 191.948V193.34C325.716 193.704 325.982 194 326.314 194H316.409C316.077 194 315.811 193.704 315.811 193.34V191.948C315.811 191.584 316.077 191.287 316.409 191.287Z",
    fill: "#463332"
  }))), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M316.438 138.848H342.793C343.139 138.848 343.419 138.565 343.419 138.216V136.766C343.419 136.417 343.139 136.134 342.793 136.134H316.438C316.092 136.134 315.811 136.417 315.811 136.766V138.216C315.811 138.565 316.092 138.848 316.438 138.848Z",
    fill: "url(#paint40_linear_10512_1016)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M326.85 163.512C326.85 162.129 322.163 159.497 320.251 155.526C318.553 152.003 317.908 145.256 317.95 140.078H341.284C341.275 141.164 341.242 142.322 341.171 143.504H326.655C326.655 143.504 325.929 152.147 327.642 157.32C328.851 160.971 329.506 162.321 329.506 163.953C329.506 165.584 325.777 168.054 326.233 190.014H317.95C318.007 185.324 318.444 176.112 319.81 172.925C321.873 168.092 326.854 164.891 326.854 163.512H326.85Z",
    fill: "#398191"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M316.409 136.135H326.314C325.982 136.135 325.716 136.431 325.716 136.795V138.188C325.716 138.551 325.982 138.848 326.314 138.848H316.409C316.077 138.848 315.811 138.551 315.811 138.188V136.795C315.811 136.431 316.077 136.135 316.409 136.135Z",
    fill: "#463332"
  }))), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M325.631 159.961C324.184 158.616 322.386 156.937 321.433 154.951C320.84 153.716 320.38 151.974 320.038 150.031H339.069C338.704 151.917 338.216 153.592 337.575 154.783C336.408 156.946 334.701 158.707 333.33 160.124C331.916 161.583 330.763 162.684 330.265 163.43C329.634 164.373 329.445 164.287 328.899 163.43C328.434 162.698 327.153 161.387 325.631 159.966V159.961Z",
    fill: "url(#paint41_linear_10512_1016)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M320.247 151.079C320.176 150.735 320.104 150.39 320.038 150.031H339.069C338.998 150.39 338.922 150.739 338.842 151.079H320.247Z",
    fill: "#FFE675"
  }))), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M339.743 182.304C339.804 183.491 339.956 186.802 339.966 188.692H319.288C319.335 186.601 319.464 183.94 319.601 182.304C324.193 182.246 326.987 179.428 329.534 179.428C332.082 179.428 335.45 182.328 339.743 182.304Z",
    fill: "url(#paint42_linear_10512_1016)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M329.155 180.102C326.618 180.102 323.046 182.864 319.597 182.304C323.696 182.395 326.983 179.428 329.53 179.428C332.078 179.428 335.446 182.328 339.739 182.304C339.748 182.5 339.762 182.768 339.776 183.06C335.322 183.002 331.812 180.098 329.155 180.098V180.102Z",
    fill: "#FFE675"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M322.917 150.031C323.169 151.079 323.458 152.017 323.814 152.749C327.315 160.028 333.491 161.301 338.182 152.601C338.453 152.099 338.69 151.496 338.903 150.83C338.562 152.381 338.13 153.764 337.58 154.783C336.413 156.946 334.705 158.707 333.334 160.124C331.921 161.583 330.768 162.684 330.27 163.43C329.639 164.373 329.449 164.287 328.904 163.43C328.439 162.698 327.163 161.387 325.635 159.966C324.189 158.621 322.391 156.941 321.437 154.955C320.844 153.721 320.384 151.979 320.043 150.036H322.922L322.917 150.031Z",
    fill: "#AA2424"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M319.597 182.305C323.6 182.324 326.622 179.778 329.041 179.467C327.694 180.017 326.817 180.764 326.817 181.773C326.817 183.86 330.09 184.941 333.524 184.941C337.333 184.941 339.582 183.554 339.7 182.271C339.715 182.271 339.724 182.271 339.738 182.271C339.8 183.467 339.952 186.793 339.961 188.688H319.284C319.331 186.588 319.488 183.874 319.597 182.3V182.305Z",
    fill: "#AA2424"
  }))), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M329.615 166.828C329.956 166.828 330.232 166.55 330.232 166.206C330.232 165.863 329.956 165.584 329.615 165.584C329.275 165.584 328.998 165.863 328.998 166.206C328.998 166.55 329.275 166.828 329.615 166.828Z",
    fill: "#ED9C47"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M329.412 178.438C329.752 178.438 330.028 178.159 330.028 177.815C330.028 177.472 329.752 177.193 329.412 177.193C329.071 177.193 328.795 177.472 328.795 177.815C328.795 178.159 329.071 178.438 329.412 178.438Z",
    fill: "#ED9C47"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M328.519 170.604C328.519 170.848 328.714 171.045 328.956 171.045C329.198 171.045 329.392 170.848 329.392 170.604C329.392 170.36 329.198 170.164 328.956 170.164C328.714 170.164 328.519 170.36 328.519 170.604Z",
    fill: "#ED9C47"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M330.313 168.32C330.313 168.502 330.46 168.651 330.64 168.651C330.82 168.651 330.967 168.502 330.967 168.32C330.967 168.139 330.82 167.99 330.64 167.99C330.46 167.99 330.313 168.139 330.313 168.32Z",
    fill: "#ED9C47"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M329.326 176.155C329.507 176.155 329.653 176.007 329.653 175.824C329.653 175.642 329.507 175.494 329.326 175.494C329.145 175.494 328.998 175.642 328.998 175.824C328.998 176.007 329.145 176.155 329.326 176.155Z",
    fill: "#ED9C47"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M327.969 178.893C327.969 179.075 328.116 179.223 328.296 179.223C328.477 179.223 328.624 179.075 328.624 178.893C328.624 178.711 328.477 178.562 328.296 178.562C328.116 178.562 327.969 178.711 327.969 178.893Z",
    fill: "#ED9C47"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M330.602 179.098C330.602 179.28 330.749 179.428 330.929 179.428C331.109 179.428 331.257 179.28 331.257 179.098C331.257 178.916 331.109 178.768 330.929 178.768C330.749 178.768 330.602 178.916 330.602 179.098Z",
    fill: "#ED9C47"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M328.709 167.617C328.89 167.617 329.036 167.47 329.036 167.287C329.036 167.105 328.89 166.957 328.709 166.957C328.528 166.957 328.382 167.105 328.382 167.287C328.382 167.47 328.528 167.617 328.709 167.617Z",
    fill: "#ED9C47"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M329.245 171.805C329.245 171.987 329.393 172.135 329.573 172.135C329.753 172.135 329.9 171.987 329.9 171.805C329.9 171.623 329.753 171.475 329.573 171.475C329.393 171.475 329.245 171.623 329.245 171.805Z",
    fill: "#ED9C47"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M329.577 165.59C329.321 165.647 329.131 165.872 329.131 166.15C329.131 166.466 329.387 166.724 329.7 166.724C329.914 166.724 330.103 166.604 330.198 166.427C330.113 166.667 329.885 166.834 329.62 166.834C329.278 166.834 329.003 166.557 329.003 166.212C329.003 165.882 329.259 165.614 329.582 165.59H329.577Z",
    fill: "#AA2424"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M329.197 177.232C329.046 177.333 328.946 177.51 328.946 177.706C328.946 178.022 329.202 178.28 329.515 178.28C329.719 178.28 329.895 178.175 329.994 178.012C329.914 178.261 329.681 178.438 329.411 178.438C329.069 178.438 328.794 178.161 328.794 177.816C328.794 177.548 328.965 177.319 329.202 177.232H329.197Z",
    fill: "#AA2424"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M328.875 170.17C328.733 170.232 328.633 170.376 328.633 170.538C328.633 170.763 328.813 170.945 329.036 170.945C329.164 170.945 329.278 170.883 329.349 170.792C329.278 170.94 329.131 171.046 328.956 171.046C328.714 171.046 328.519 170.849 328.519 170.605C328.519 170.39 328.671 170.213 328.875 170.175V170.17Z",
    fill: "#AA2424"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M330.592 167.996C330.488 168.044 330.417 168.149 330.417 168.274C330.417 168.441 330.554 168.58 330.721 168.58C330.801 168.58 330.868 168.551 330.924 168.499C330.868 168.594 330.763 168.656 330.645 168.656C330.464 168.656 330.317 168.508 330.317 168.326C330.317 168.159 330.436 168.025 330.592 168.001V167.996Z",
    fill: "#AA2424"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M329.212 175.514C329.136 175.571 329.088 175.657 329.088 175.758C329.088 175.925 329.226 176.064 329.392 176.064C329.492 176.064 329.577 176.016 329.634 175.94C329.587 176.064 329.468 176.155 329.326 176.155C329.145 176.155 328.998 176.007 328.998 175.825C328.998 175.681 329.089 175.562 329.212 175.514Z",
    fill: "#AA2424"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M328.182 178.582C328.121 178.639 328.083 178.716 328.083 178.807C328.083 178.974 328.22 179.113 328.386 179.113C328.472 179.113 328.552 179.075 328.605 179.018C328.557 179.137 328.438 179.223 328.301 179.223C328.121 179.223 327.974 179.075 327.974 178.893C327.974 178.754 328.059 178.635 328.182 178.587V178.582Z",
    fill: "#AA2424"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M330.773 178.812C330.72 178.865 330.687 178.942 330.687 179.023C330.687 179.191 330.825 179.329 330.991 179.329C331.1 179.329 331.195 179.272 331.247 179.181C331.209 179.325 331.081 179.435 330.929 179.435C330.749 179.435 330.602 179.286 330.602 179.104C330.602 178.98 330.673 178.87 330.773 178.812Z",
    fill: "#AA2424"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M328.652 166.963C328.552 167.011 328.486 167.116 328.486 167.236C328.486 167.403 328.623 167.542 328.79 167.542C328.87 167.542 328.941 167.508 328.993 167.461C328.937 167.556 328.832 167.623 328.714 167.623C328.533 167.623 328.386 167.475 328.386 167.293C328.386 167.13 328.505 166.996 328.657 166.968L328.652 166.963Z",
    fill: "#AA2424"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M329.402 171.523C329.359 171.576 329.331 171.643 329.331 171.72C329.331 171.887 329.468 172.026 329.634 172.026C329.748 172.026 329.843 171.964 329.895 171.873C329.867 172.026 329.734 172.141 329.573 172.141C329.392 172.141 329.245 171.992 329.245 171.811C329.245 171.691 329.312 171.586 329.407 171.528L329.402 171.523Z",
    fill: "#AA2424"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M332.329 169.236C328.98 170.743 335.014 177.141 336.816 176.399C339.61 175.251 335.251 167.92 332.329 169.236Z",
    fill: "#FFF7E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M342.096 192.349C342.101 193.316 329.174 192.814 329.17 192.292C329.17 191.77 342.086 191.383 342.096 192.349Z",
    fill: "#FFF7E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M342.096 137.308C342.101 138.275 329.174 137.773 329.17 137.251C329.17 136.729 342.086 136.342 342.096 137.308Z",
    fill: "#FFF7E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M336.669 144.604C333.017 144.288 333.5 152.897 335.355 153.5C337.831 154.309 339.639 144.863 336.669 144.604Z",
    fill: "#FFF7E6"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M334.653 154.653C332.893 153.528 330.474 158.587 331.351 159.079C332.708 159.845 336.033 155.538 334.653 154.653Z",
    fill: "#FFF7E6"
  }))), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M34.78 73.336C32.8013 73.336 31.1027 72.916 29.684 72.076C28.2653 71.2173 27.1733 70.032 26.408 68.52C25.6427 66.9893 25.26 65.2253 25.26 63.228C25.26 61.2307 25.6427 59.4667 26.408 57.936C27.1733 56.4053 28.2653 55.2107 29.684 54.352C31.1027 53.4933 32.8013 53.064 34.78 53.064C37.132 53.064 39.0547 53.652 40.548 54.828C42.06 55.9853 43.0027 57.6187 43.376 59.728H39.428C39.1853 58.664 38.6627 57.8333 37.86 57.236C37.076 56.62 36.0307 56.312 34.724 56.312C32.9133 56.312 31.4947 56.928 30.468 58.16C29.4413 59.392 28.928 61.0813 28.928 63.228C28.928 65.3747 29.4413 67.064 30.468 68.296C31.4947 69.5093 32.9133 70.116 34.724 70.116C36.0307 70.116 37.076 69.836 37.86 69.276C38.6627 68.6973 39.1853 67.904 39.428 66.896H43.376C43.0027 68.912 42.06 70.4893 40.548 71.628C39.0547 72.7667 37.132 73.336 34.78 73.336ZM51.3645 73.336C49.6285 73.336 48.2845 72.7947 47.3325 71.712C46.3992 70.6293 45.9325 69.0427 45.9325 66.952V59.112H49.4885V66.616C49.4885 67.8107 49.7312 68.7253 50.2165 69.36C50.7019 69.9947 51.4672 70.312 52.5125 70.312C53.5019 70.312 54.3139 69.9573 54.9485 69.248C55.6019 68.5387 55.9285 67.5493 55.9285 66.28V59.112H59.5125V73H56.3485L56.0685 70.648C55.6392 71.4693 55.0139 72.1227 54.1925 72.608C53.3899 73.0933 52.4472 73.336 51.3645 73.336ZM62.8837 73V59.112H66.0757L66.4117 61.716C66.9157 60.82 67.597 60.1107 68.4557 59.588C69.333 59.0467 70.3597 58.776 71.5357 58.776V62.556H70.5277C69.7437 62.556 69.0437 62.6773 68.4277 62.92C67.8117 63.1627 67.3264 63.5827 66.9717 64.18C66.6357 64.7773 66.4677 65.608 66.4677 66.672V73H62.8837ZM73.6773 73V59.112H76.8693L77.2053 61.716C77.7093 60.82 78.3906 60.1107 79.2493 59.588C80.1266 59.0467 81.1533 58.776 82.3293 58.776V62.556H81.3213C80.5373 62.556 79.8373 62.6773 79.2213 62.92C78.6053 63.1627 78.1199 63.5827 77.7653 64.18C77.4293 64.7773 77.2613 65.608 77.2613 66.672V73H73.6773ZM86.4028 56.956C85.7495 56.956 85.2081 56.76 84.7788 56.368C84.3681 55.976 84.1628 55.4813 84.1628 54.884C84.1628 54.2867 84.3681 53.8013 84.7788 53.428C85.2081 53.036 85.7495 52.84 86.4028 52.84C87.0561 52.84 87.5881 53.036 87.9988 53.428C88.4281 53.8013 88.6428 54.2867 88.6428 54.884C88.6428 55.4813 88.4281 55.976 87.9988 56.368C87.5881 56.76 87.0561 56.956 86.4028 56.956ZM84.6108 73V59.112H88.1948V73H84.6108ZM98.4317 73.336C97.013 73.336 95.7623 73.028 94.6797 72.412C93.597 71.796 92.7383 70.9373 92.1037 69.836C91.4877 68.7347 91.1797 67.4747 91.1797 66.056C91.1797 64.6373 91.4877 63.3773 92.1037 62.276C92.7383 61.1747 93.597 60.316 94.6797 59.7C95.7623 59.084 97.013 58.776 98.4317 58.776C100.205 58.776 101.698 59.2427 102.912 60.176C104.125 61.0907 104.9 62.36 105.236 63.984H101.456C101.269 63.312 100.896 62.7893 100.336 62.416C99.7943 62.024 99.1503 61.828 98.4037 61.828C97.4143 61.828 96.5743 62.2013 95.8837 62.948C95.193 63.6947 94.8477 64.7307 94.8477 66.056C94.8477 67.3813 95.193 68.4173 95.8837 69.164C96.5743 69.9107 97.4143 70.284 98.4037 70.284C99.1503 70.284 99.7943 70.0973 100.336 69.724C100.896 69.3507 101.269 68.8187 101.456 68.128H105.236C104.9 69.696 104.125 70.956 102.912 71.908C101.698 72.86 100.205 73.336 98.4317 73.336ZM113.317 73.336C111.581 73.336 110.237 72.7947 109.285 71.712C108.351 70.6293 107.885 69.0427 107.885 66.952V59.112H111.441V66.616C111.441 67.8107 111.683 68.7253 112.169 69.36C112.654 69.9947 113.419 70.312 114.465 70.312C115.454 70.312 116.266 69.9573 116.901 69.248C117.554 68.5387 117.881 67.5493 117.881 66.28V59.112H121.465V73H118.301L118.021 70.648C117.591 71.4693 116.966 72.1227 116.145 72.608C115.342 73.0933 114.399 73.336 113.317 73.336ZM124.836 73V52.84H128.42V73H124.836ZM136.982 73.336C135.246 73.336 133.902 72.7947 132.95 71.712C132.017 70.6293 131.55 69.0427 131.55 66.952V59.112H135.106V66.616C135.106 67.8107 135.349 68.7253 135.834 69.36C136.319 69.9947 137.085 70.312 138.13 70.312C139.119 70.312 139.931 69.9573 140.566 69.248C141.219 68.5387 141.546 67.5493 141.546 66.28V59.112H145.13V73H141.966L141.686 70.648C141.257 71.4693 140.631 72.1227 139.81 72.608C139.007 73.0933 138.065 73.336 136.982 73.336ZM148.501 73V59.112H151.665L151.973 60.988C152.421 60.316 153.009 59.784 153.737 59.392C154.484 58.9813 155.342 58.776 156.313 58.776C158.46 58.776 159.981 59.6067 160.877 61.268C161.381 60.5027 162.053 59.896 162.893 59.448C163.752 59 164.685 58.776 165.693 58.776C167.504 58.776 168.894 59.3173 169.865 60.4C170.836 61.4827 171.321 63.0693 171.321 65.16V73H167.737V65.496C167.737 64.3013 167.504 63.3867 167.037 62.752C166.589 62.1173 165.889 61.8 164.937 61.8C163.966 61.8 163.182 62.1547 162.585 62.864C162.006 63.5733 161.717 64.5627 161.717 65.832V73H158.133V65.496C158.133 64.3013 157.9 63.3867 157.433 62.752C156.966 62.1173 156.248 61.8 155.277 61.8C154.325 61.8 153.55 62.1547 152.953 62.864C152.374 63.5733 152.085 64.5627 152.085 65.832V73H148.501ZM187.136 73.308C185.698 73.308 184.448 73.0653 183.384 72.58C182.32 72.076 181.489 71.376 180.892 70.48C180.313 69.584 180.024 68.5387 180.024 67.344C180.024 66.0747 180.378 64.9267 181.088 63.9C181.797 62.8733 182.852 62.052 184.252 61.436C183.692 60.7827 183.29 60.1667 183.048 59.588C182.805 59.0093 182.684 58.3933 182.684 57.74C182.684 56.844 182.908 56.0507 183.356 55.36C183.804 54.6507 184.438 54.0907 185.26 53.68C186.1 53.2693 187.098 53.064 188.256 53.064C189.432 53.064 190.43 53.2787 191.252 53.708C192.073 54.1373 192.689 54.716 193.1 55.444C193.529 56.172 193.725 56.984 193.688 57.88H190.272C190.272 57.1893 190.066 56.676 189.656 56.34C189.264 55.9853 188.788 55.808 188.228 55.808C187.593 55.808 187.08 55.9853 186.688 56.34C186.314 56.6947 186.128 57.152 186.128 57.712C186.128 58.1787 186.277 58.6547 186.576 59.14C186.874 59.6253 187.313 60.1853 187.892 60.82L193.38 66.252C193.772 65.6173 194.182 64.88 194.612 64.04L195.228 62.808H198.896L197.916 64.712C197.169 66.224 196.422 67.5027 195.676 68.548L200.184 73H195.9L193.716 70.816C192.764 71.6933 191.746 72.328 190.664 72.72C189.6 73.112 188.424 73.308 187.136 73.308ZM183.496 67.12C183.496 68.0347 183.832 68.8093 184.504 69.444C185.194 70.06 186.109 70.368 187.248 70.368C188.872 70.368 190.281 69.7893 191.476 68.632L186.296 63.508C185.344 63.9187 184.634 64.432 184.168 65.048C183.72 65.664 183.496 66.3547 183.496 67.12ZM25.904 103V83.4H33.156C34.724 83.4 36.0213 83.6613 37.048 84.184C38.0747 84.7067 38.84 85.4253 39.344 86.34C39.848 87.2547 40.1 88.2813 40.1 89.42C40.1 90.5027 39.8573 91.5013 39.372 92.416C38.8867 93.312 38.1307 94.04 37.104 94.6C36.0773 95.1413 34.7613 95.412 33.156 95.412H29.488V103H25.904ZM29.488 92.5H32.932C34.1827 92.5 35.0787 92.2293 35.62 91.688C36.18 91.128 36.46 90.372 36.46 89.42C36.46 88.4493 36.18 87.6933 35.62 87.152C35.0787 86.592 34.1827 86.312 32.932 86.312H29.488V92.5ZM48.5569 103.336C47.1569 103.336 45.9155 103.037 44.8329 102.44C43.7502 101.843 42.9009 101.003 42.2849 99.92C41.6689 98.8373 41.3609 97.5867 41.3609 96.168C41.3609 94.7307 41.6595 93.452 42.2569 92.332C42.8729 91.212 43.7129 90.344 44.7769 89.728C45.8595 89.0933 47.1289 88.776 48.5849 88.776C49.9475 88.776 51.1515 89.0747 52.1969 89.672C53.2422 90.2693 54.0542 91.0907 54.6329 92.136C55.2302 93.1627 55.5289 94.3107 55.5289 95.58C55.5289 95.7853 55.5195 96 55.5009 96.224C55.5009 96.448 55.4915 96.6813 55.4729 96.924H44.9169C44.9915 98.0067 45.3649 98.856 46.0369 99.472C46.7275 100.088 47.5582 100.396 48.5289 100.396C49.2569 100.396 49.8635 100.237 50.3489 99.92C50.8529 99.584 51.2262 99.1547 51.4689 98.632H55.1089C54.8475 99.5093 54.4089 100.312 53.7929 101.04C53.1955 101.749 52.4489 102.309 51.5529 102.72C50.6755 103.131 49.6769 103.336 48.5569 103.336ZM48.5849 91.688C47.7075 91.688 46.9329 91.94 46.2609 92.444C45.5889 92.9293 45.1595 93.676 44.9729 94.684H51.8889C51.8329 93.7693 51.4969 93.0413 50.8809 92.5C50.2649 91.9587 49.4995 91.688 48.5849 91.688ZM64.6192 103.336C63.3126 103.336 62.1459 103.019 61.1192 102.384C60.0926 101.749 59.2806 100.881 58.6832 99.78C58.0859 98.6787 57.7872 97.428 57.7872 96.028C57.7872 94.628 58.0859 93.3867 58.6832 92.304C59.2806 91.2027 60.0926 90.344 61.1192 89.728C62.1459 89.0933 63.3126 88.776 64.6192 88.776C65.6646 88.776 66.5792 88.972 67.3632 89.364C68.1472 89.756 68.7819 90.3067 69.2672 91.016V82.84H72.8512V103H69.6592L69.2672 101.012C68.8192 101.628 68.2219 102.169 67.4752 102.636C66.7472 103.103 65.7952 103.336 64.6192 103.336ZM65.3752 100.2C66.5326 100.2 67.4752 99.8173 68.2032 99.052C68.9499 98.268 69.3232 97.2693 69.3232 96.056C69.3232 94.8427 68.9499 93.8533 68.2032 93.088C67.4752 92.304 66.5326 91.912 65.3752 91.912C64.2366 91.912 63.2939 92.2947 62.5472 93.06C61.8006 93.8253 61.4272 94.8147 61.4272 96.028C61.4272 97.2413 61.8006 98.24 62.5472 99.024C63.2939 99.808 64.2366 100.2 65.3752 100.2ZM80.9809 103.336C79.7862 103.336 78.8062 103.149 78.0409 102.776C77.2755 102.384 76.7062 101.871 76.3329 101.236C75.9595 100.601 75.7729 99.9013 75.7729 99.136C75.7729 97.848 76.2769 96.8027 77.2849 96C78.2929 95.1973 79.8049 94.796 81.8209 94.796H85.3489V94.46C85.3489 93.508 85.0782 92.808 84.5369 92.36C83.9955 91.912 83.3235 91.688 82.5209 91.688C81.7929 91.688 81.1582 91.8653 80.6169 92.22C80.0755 92.556 79.7395 93.06 79.6089 93.732H76.1089C76.2022 92.724 76.5382 91.8467 77.1169 91.1C77.7142 90.3533 78.4795 89.784 79.4129 89.392C80.3462 88.9813 81.3915 88.776 82.5489 88.776C84.5275 88.776 86.0862 89.2707 87.2249 90.26C88.3635 91.2493 88.9329 92.6493 88.9329 94.46V103H85.8809L85.5449 100.76C85.1342 101.507 84.5555 102.123 83.8089 102.608C83.0809 103.093 82.1382 103.336 80.9809 103.336ZM81.7929 100.536C82.8195 100.536 83.6129 100.2 84.1729 99.528C84.7515 98.856 85.1155 98.0253 85.2649 97.036H82.2129C81.2609 97.036 80.5795 97.2133 80.1689 97.568C79.7582 97.904 79.5529 98.324 79.5529 98.828C79.5529 99.3693 79.7582 99.7893 80.1689 100.088C80.5795 100.387 81.1209 100.536 81.7929 100.536ZM97.925 98.856C97.253 98.856 96.6277 98.7813 96.049 98.632L95.013 99.668C95.3304 99.836 95.7597 99.976 96.301 100.088C96.8424 100.2 97.7197 100.312 98.933 100.424C100.781 100.592 102.125 101.031 102.965 101.74C103.805 102.449 104.225 103.429 104.225 104.68C104.225 105.501 104.001 106.276 103.553 107.004C103.105 107.751 102.414 108.348 101.481 108.796C100.548 109.263 99.353 109.496 97.897 109.496C95.9184 109.496 94.3224 109.123 93.109 108.376C91.8957 107.648 91.289 106.547 91.289 105.072C91.289 103.821 91.8957 102.739 93.109 101.824C92.7357 101.656 92.409 101.479 92.129 101.292C91.8677 101.105 91.6344 100.909 91.429 100.704V100.06L93.865 97.484C92.7824 96.532 92.241 95.3093 92.241 93.816C92.241 92.8827 92.465 92.0333 92.913 91.268C93.3797 90.5027 94.033 89.896 94.873 89.448C95.713 89 96.7304 88.776 97.925 88.776C98.709 88.776 99.437 88.888 100.109 89.112H105.373V91.296L102.993 91.464C103.366 92.1733 103.553 92.9573 103.553 93.816C103.553 94.7493 103.329 95.5987 102.881 96.364C102.433 97.1293 101.78 97.736 100.921 98.184C100.081 98.632 99.0824 98.856 97.925 98.856ZM97.925 96.112C98.653 96.112 99.2504 95.916 99.717 95.524C100.202 95.132 100.445 94.572 100.445 93.844C100.445 93.116 100.202 92.556 99.717 92.164C99.2504 91.772 98.653 91.576 97.925 91.576C97.1597 91.576 96.5437 91.772 96.077 92.164C95.6104 92.556 95.377 93.116 95.377 93.844C95.377 94.572 95.6104 95.132 96.077 95.524C96.5437 95.916 97.1597 96.112 97.925 96.112ZM94.565 104.708C94.565 105.399 94.8824 105.912 95.517 106.248C96.1704 106.603 96.9637 106.78 97.897 106.78C98.793 106.78 99.521 106.593 100.081 106.22C100.641 105.865 100.921 105.38 100.921 104.764C100.921 104.26 100.734 103.84 100.361 103.504C100.006 103.168 99.2877 102.963 98.205 102.888C97.4397 102.832 96.7304 102.748 96.077 102.636C95.5357 102.935 95.1437 103.261 94.901 103.616C94.677 103.971 94.565 104.335 94.565 104.708ZM113.796 103.336C112.452 103.336 111.238 103.028 110.156 102.412C109.092 101.796 108.242 100.947 107.608 99.864C106.992 98.7627 106.684 97.4933 106.684 96.056C106.684 94.6187 107.001 93.3587 107.636 92.276C108.27 91.1747 109.12 90.316 110.184 89.7C111.266 89.084 112.48 88.776 113.824 88.776C115.149 88.776 116.344 89.084 117.408 89.7C118.49 90.316 119.34 91.1747 119.956 92.276C120.59 93.3587 120.908 94.6187 120.908 96.056C120.908 97.4933 120.59 98.7627 119.956 99.864C119.34 100.947 118.49 101.796 117.408 102.412C116.325 103.028 115.121 103.336 113.796 103.336ZM113.796 100.228C114.729 100.228 115.541 99.8827 116.232 99.192C116.922 98.4827 117.268 97.4373 117.268 96.056C117.268 94.6747 116.922 93.6387 116.232 92.948C115.541 92.2387 114.738 91.884 113.824 91.884C112.872 91.884 112.05 92.2387 111.36 92.948C110.688 93.6387 110.352 94.6747 110.352 96.056C110.352 97.4373 110.688 98.4827 111.36 99.192C112.05 99.8827 112.862 100.228 113.796 100.228ZM128.809 98.856C128.137 98.856 127.512 98.7813 126.933 98.632L125.897 99.668C126.214 99.836 126.644 99.976 127.185 100.088C127.726 100.2 128.604 100.312 129.817 100.424C131.665 100.592 133.009 101.031 133.849 101.74C134.689 102.449 135.109 103.429 135.109 104.68C135.109 105.501 134.885 106.276 134.437 107.004C133.989 107.751 133.298 108.348 132.365 108.796C131.432 109.263 130.237 109.496 128.781 109.496C126.802 109.496 125.206 109.123 123.993 108.376C122.78 107.648 122.173 106.547 122.173 105.072C122.173 103.821 122.78 102.739 123.993 101.824C123.62 101.656 123.293 101.479 123.013 101.292C122.752 101.105 122.518 100.909 122.313 100.704V100.06L124.749 97.484C123.666 96.532 123.125 95.3093 123.125 93.816C123.125 92.8827 123.349 92.0333 123.797 91.268C124.264 90.5027 124.917 89.896 125.757 89.448C126.597 89 127.614 88.776 128.809 88.776C129.593 88.776 130.321 88.888 130.993 89.112H136.257V91.296L133.877 91.464C134.25 92.1733 134.437 92.9573 134.437 93.816C134.437 94.7493 134.213 95.5987 133.765 96.364C133.317 97.1293 132.664 97.736 131.805 98.184C130.965 98.632 129.966 98.856 128.809 98.856ZM128.809 96.112C129.537 96.112 130.134 95.916 130.601 95.524C131.086 95.132 131.329 94.572 131.329 93.844C131.329 93.116 131.086 92.556 130.601 92.164C130.134 91.772 129.537 91.576 128.809 91.576C128.044 91.576 127.428 91.772 126.961 92.164C126.494 92.556 126.261 93.116 126.261 93.844C126.261 94.572 126.494 95.132 126.961 95.524C127.428 95.916 128.044 96.112 128.809 96.112ZM125.449 104.708C125.449 105.399 125.766 105.912 126.401 106.248C127.054 106.603 127.848 106.78 128.781 106.78C129.677 106.78 130.405 106.593 130.965 106.22C131.525 105.865 131.805 105.38 131.805 104.764C131.805 104.26 131.618 103.84 131.245 103.504C130.89 103.168 130.172 102.963 129.089 102.888C128.324 102.832 127.614 102.748 126.961 102.636C126.42 102.935 126.028 103.261 125.785 103.616C125.561 103.971 125.449 104.335 125.449 104.708ZM140.298 109.16L143.518 102.076H142.678L137.274 89.112H141.166L145.058 98.884L149.118 89.112H152.926L144.106 109.16H140.298ZM32.596 133.336C31.1587 133.336 29.8893 133.093 28.788 132.608C27.6867 132.104 26.8187 131.395 26.184 130.48C25.5493 129.547 25.2227 128.417 25.204 127.092H28.984C29.0213 128.007 29.348 128.781 29.964 129.416C30.5987 130.032 31.4667 130.34 32.568 130.34C33.52 130.34 34.276 130.116 34.836 129.668C35.396 129.201 35.676 128.585 35.676 127.82C35.676 127.017 35.424 126.392 34.92 125.944C34.4347 125.496 33.7813 125.132 32.96 124.852C32.1387 124.572 31.2613 124.273 30.328 123.956C28.816 123.433 27.6587 122.761 26.856 121.94C26.072 121.119 25.68 120.027 25.68 118.664C25.6613 117.507 25.932 116.517 26.492 115.696C27.0707 114.856 27.8547 114.212 28.844 113.764C29.8333 113.297 30.972 113.064 32.26 113.064C33.5667 113.064 34.7147 113.297 35.704 113.764C36.712 114.231 37.496 114.884 38.056 115.724C38.6347 116.564 38.9427 117.563 38.98 118.72H35.144C35.1253 118.029 34.8547 117.423 34.332 116.9C33.828 116.359 33.1187 116.088 32.204 116.088C31.42 116.069 30.7573 116.265 30.216 116.676C29.6933 117.068 29.432 117.647 29.432 118.412C29.432 119.065 29.6373 119.588 30.048 119.98C30.4587 120.353 31.0187 120.671 31.728 120.932C32.4373 121.193 33.2493 121.473 34.164 121.772C35.1347 122.108 36.0213 122.5 36.824 122.948C37.6267 123.396 38.2707 123.993 38.756 124.74C39.2413 125.468 39.484 126.411 39.484 127.568C39.484 128.595 39.2227 129.547 38.7 130.424C38.1773 131.301 37.4027 132.011 36.376 132.552C35.3493 133.075 34.0893 133.336 32.596 133.336ZM48.883 133.336C47.539 133.336 46.3257 133.028 45.243 132.412C44.179 131.796 43.3297 130.947 42.695 129.864C42.079 128.763 41.771 127.493 41.771 126.056C41.771 124.619 42.0884 123.359 42.723 122.276C43.3577 121.175 44.207 120.316 45.271 119.7C46.3537 119.084 47.567 118.776 48.911 118.776C50.2364 118.776 51.431 119.084 52.495 119.7C53.5777 120.316 54.427 121.175 55.043 122.276C55.6777 123.359 55.995 124.619 55.995 126.056C55.995 127.493 55.6777 128.763 55.043 129.864C54.427 130.947 53.5777 131.796 52.495 132.412C51.4124 133.028 50.2084 133.336 48.883 133.336ZM48.883 130.228C49.8164 130.228 50.6284 129.883 51.319 129.192C52.0097 128.483 52.355 127.437 52.355 126.056C52.355 124.675 52.0097 123.639 51.319 122.948C50.6284 122.239 49.8257 121.884 48.911 121.884C47.959 121.884 47.1377 122.239 46.447 122.948C45.775 123.639 45.439 124.675 45.439 126.056C45.439 127.437 45.775 128.483 46.447 129.192C47.1377 129.883 47.9497 130.228 48.883 130.228ZM58.8915 133V112.84H62.4755V133H58.8915ZM71.0376 133.336C69.3016 133.336 67.9576 132.795 67.0056 131.712C66.0723 130.629 65.6056 129.043 65.6056 126.952V119.112H69.1616V126.616C69.1616 127.811 69.4043 128.725 69.8896 129.36C70.3749 129.995 71.1403 130.312 72.1856 130.312C73.1749 130.312 73.9869 129.957 74.6216 129.248C75.2749 128.539 75.6016 127.549 75.6016 126.28V119.112H79.1856V133H76.0216L75.7416 130.648C75.3123 131.469 74.6869 132.123 73.8656 132.608C73.0629 133.093 72.1203 133.336 71.0376 133.336ZM88.7448 133C87.2888 133 86.1221 132.645 85.2448 131.936C84.3674 131.227 83.9288 129.967 83.9288 128.156V122.108H81.5488V119.112H83.9288L84.3488 115.388H87.5128V119.112H91.2648V122.108H87.5128V128.184C87.5128 128.856 87.6528 129.323 87.9328 129.584C88.2314 129.827 88.7354 129.948 89.4448 129.948H91.1808V133H88.7448ZM95.9659 116.956C95.3126 116.956 94.7712 116.76 94.3419 116.368C93.9312 115.976 93.7259 115.481 93.7259 114.884C93.7259 114.287 93.9312 113.801 94.3419 113.428C94.7712 113.036 95.3126 112.84 95.9659 112.84C96.6192 112.84 97.1512 113.036 97.5619 113.428C97.9912 113.801 98.2059 114.287 98.2059 114.884C98.2059 115.481 97.9912 115.976 97.5619 116.368C97.1512 116.76 96.6192 116.956 95.9659 116.956ZM94.1739 133V119.112H97.7579V133H94.1739ZM107.855 133.336C106.511 133.336 105.297 133.028 104.215 132.412C103.151 131.796 102.301 130.947 101.667 129.864C101.051 128.763 100.743 127.493 100.743 126.056C100.743 124.619 101.06 123.359 101.695 122.276C102.329 121.175 103.179 120.316 104.243 119.7C105.325 119.084 106.539 118.776 107.883 118.776C109.208 118.776 110.403 119.084 111.467 119.7C112.549 120.316 113.399 121.175 114.015 122.276C114.649 123.359 114.967 124.619 114.967 126.056C114.967 127.493 114.649 128.763 114.015 129.864C113.399 130.947 112.549 131.796 111.467 132.412C110.384 133.028 109.18 133.336 107.855 133.336ZM107.855 130.228C108.788 130.228 109.6 129.883 110.291 129.192C110.981 128.483 111.327 127.437 111.327 126.056C111.327 124.675 110.981 123.639 110.291 122.948C109.6 122.239 108.797 121.884 107.883 121.884C106.931 121.884 106.109 122.239 105.419 122.948C104.747 123.639 104.411 124.675 104.411 126.056C104.411 127.437 104.747 128.483 105.419 129.192C106.109 129.883 106.921 130.228 107.855 130.228ZM117.863 133V119.112H121.027L121.307 121.464C121.737 120.643 122.353 119.989 123.155 119.504C123.977 119.019 124.938 118.776 126.039 118.776C127.757 118.776 129.091 119.317 130.043 120.4C130.995 121.483 131.471 123.069 131.471 125.16V133H127.887V125.496C127.887 124.301 127.645 123.387 127.159 122.752C126.674 122.117 125.918 121.8 124.891 121.8C123.883 121.8 123.053 122.155 122.399 122.864C121.765 123.573 121.447 124.563 121.447 125.832V133H117.863Z",
    fill: "#FFB900"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10512_1016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.9481 20.8595H45.2965V27.1487H49.4062V29.561H42.9481V20.8595ZM50.7062 20.8595H57.4997V22.9272H53.0126V24.2626H57.0804V26.1579H53.0126V27.5364H57.5417V29.6041H50.7062V20.8595ZM61.9868 20.8164H64.2513L67.8578 29.561H65.3417L64.7126 28.0103H61.4417L60.8546 29.561H58.3804L61.9868 20.8164ZM64.0417 26.1149L63.1191 23.6595L62.1546 26.1149H64.0417ZM68.9901 20.8595H72.261C75.2804 20.8595 77.0417 22.6256 77.0417 25.1672C77.0417 27.6656 75.2804 29.5179 72.2191 29.5179H68.9901V20.8595ZM72.261 27.4072C73.6449 27.4072 74.6094 26.6318 74.6094 25.2103V25.1672C74.6094 23.7887 73.6868 22.9703 72.261 22.9703H71.2965V27.4072H72.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0935 41.28L48.3161 40.5477L46.429 34.6031L50.329 33.3108L49.6161 31.0277L43.4935 33.0523L46.0935 41.28ZM31.5419 26.3323L32.2548 24.0492L38.0419 25.9877L39.929 20L42.1516 20.7323L39.5516 29.0031L31.5419 26.3323ZM45.3806 41.6677L43.4935 43.0892L39.8871 38.0062L31.3323 43.52L25 48L31.4581 38.0062L34.6871 32.6646L29.7387 28.96L31.1226 27.0215L38 32.1477L31.8774 40.9354L40.4323 34.6462L45.3806 41.6677Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10512_1016)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 147,
    width: 48,
    height: 28,
    rx: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 147,
    width: 48,
    height: 28,
    rx: 14,
    fill: "url(#paint43_linear_10512_1016)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 147,
    width: 48,
    height: 28,
    rx: 14,
    fill: "url(#paint44_linear_10512_1016)"
  }))), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6979 165.899C49.3941 165.595 49.3941 165.105 49.6979 164.802L52.7124 161.776H40.8958C40.4674 161.776 40.1168 161.426 40.1168 160.999C40.1168 160.571 40.4674 160.221 40.8958 160.221H52.7124L49.6901 157.203C49.3863 156.9 49.3863 156.41 49.6901 156.106C49.9939 155.803 50.4846 155.803 50.7884 156.106L55.1505 160.454C55.4543 160.758 55.4543 161.248 55.1505 161.551L50.7962 165.899C50.4924 166.194 49.9939 166.194 49.6979 165.899Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10512_1016",
    x: 16,
    y: 139,
    width: 64,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10512_1016"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10512_1016",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10512_1016",
    x1: 222.636,
    y1: 92.8699,
    x2: 222.636,
    y2: 165.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#339999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2E8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C767A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10512_1016",
    x1: 202.735,
    y1: 91.5141,
    x2: 202.735,
    y2: 164.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#339999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2E8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C767A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10512_1016",
    x1: 212.458,
    y1: 108.462,
    x2: 212.458,
    y2: 177.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#339999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2E8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C767A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10512_1016",
    x1: 230.627,
    y1: 113.102,
    x2: 230.627,
    y2: 176.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#339999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2E8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C767A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10512_1016",
    x1: 194.539,
    y1: 120.848,
    x2: 194.539,
    y2: 174.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#339999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2E8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C767A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10512_1016",
    x1: 212.577,
    y1: 163.3,
    x2: 212.577,
    y2: 190.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60578F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10512_1016",
    x1: 364.451,
    y1: 114.988,
    x2: 296.238,
    y2: 114.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10512_1016",
    x1: 327.267,
    y1: 181.204,
    x2: 327.267,
    y2: 158.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10512_1016",
    x1: 327.267,
    y1: 70.5837,
    x2: 327.267,
    y2: 153.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67C8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#499EB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3581A7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_10512_1016",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331.309 103.622) rotate(-180) scale(50.7237 51.1707)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B6DC41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9DC43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BD3C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_10512_1016",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331.309 103.623) rotate(-180) scale(50.7237 51.1707)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B6DC41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9DC43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BD3C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_10512_1016",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331.309 103.623) rotate(-180) scale(50.7237 51.1707)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B6DC41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9DC43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BD3C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_10512_1016",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331.309 103.622) rotate(-180) scale(50.7237 51.1706)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B6DC41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9DC43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BD3C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_10512_1016",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331.309 103.623) rotate(-180) scale(50.7237 51.1707)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B6DC41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9DC43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BD3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_10512_1016",
    x1: 361.056,
    y1: 184.132,
    x2: 293.478,
    y2: 184.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_10512_1016",
    x1: 376.502,
    y1: 119.141,
    x2: 292.425,
    y2: 119.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_10512_1016",
    x1: 229.438,
    y1: 147.027,
    x2: 229.579,
    y2: 194.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB945B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_10512_1016",
    x1: 369.676,
    y1: 184.496,
    x2: 372.073,
    y2: 193.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_10512_1016",
    x1: 371.655,
    y1: 184.229,
    x2: 371.683,
    y2: 193.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_10512_1016",
    x1: 369.683,
    y1: 184.49,
    x2: 372.079,
    y2: 193.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_10512_1016",
    x1: 358.413,
    y1: 85.8123,
    x2: 358.727,
    y2: 190.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB945B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_10512_1016",
    x1: 318.586,
    y1: 182.639,
    x2: 313.739,
    y2: 199.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_10512_1016",
    x1: 317.233,
    y1: 187.42,
    x2: 313.667,
    y2: 199.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_10512_1016",
    x1: 329.951,
    y1: 85.8979,
    x2: 330.265,
    y2: 190.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB945B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_10512_1016",
    x1: 344.891,
    y1: 76.7363,
    x2: 344.941,
    y2: 93.6958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_10512_1016",
    x1: 344.915,
    y1: 85.8533,
    x2: 345.229,
    y2: 190.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB945B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_10512_1016",
    x1: 344.927,
    y1: 89.964,
    x2: 344.961,
    y2: 101.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_10512_1016",
    x1: 321.788,
    y1: 145.716,
    x2: 321.93,
    y2: 193.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60578F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_10512_1016",
    x1: 316.447,
    y1: 145.732,
    x2: 316.589,
    y2: 193.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60578F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_10512_1016",
    x1: 348.362,
    y1: 145.636,
    x2: 348.504,
    y2: 193.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60578F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_10512_1016",
    x1: 283.278,
    y1: 148.512,
    x2: 283.331,
    y2: 166.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_10512_1016",
    x1: 259.062,
    y1: 148.583,
    x2: 259.115,
    y2: 166.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_10512_1016",
    x1: 283.247,
    y1: 137.949,
    x2: 283.279,
    y2: 148.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_10512_1016",
    x1: 263.494,
    y1: 138.008,
    x2: 263.527,
    y2: 148.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_10512_1016",
    x1: 283.328,
    y1: 165.51,
    x2: 283.413,
    y2: 194.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_10512_1016",
    x1: 329.615,
    y1: 134.995,
    x2: 329.615,
    y2: 194.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_10512_1016",
    x1: 329.615,
    y1: 136.595,
    x2: 329.615,
    y2: 193.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_10512_1016",
    x1: 329.615,
    y1: 134.996,
    x2: 329.615,
    y2: 194.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_10512_1016",
    x1: 329.615,
    y1: 134.995,
    x2: 329.615,
    y2: 194.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_10512_1016",
    x1: 329.615,
    y1: 134.996,
    x2: 329.615,
    y2: 194.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_10512_1016",
    x1: 329.615,
    y1: 134.995,
    x2: 329.615,
    y2: 194.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_10512_1016",
    x1: 329.554,
    y1: 148.596,
    x2: 329.554,
    y2: 165.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_10512_1016",
    x1: 329.624,
    y1: 178.485,
    x2: 329.624,
    y2: 189.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_10512_1016",
    x1: 72,
    y1: 175,
    x2: 21.5788,
    y2: 169.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_10512_1016",
    x1: 48,
    y1: 107.042,
    x2: 48,
    y2: 175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDA44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5F00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10512_1016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 382,
    height: 194,
    rx: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10512_1016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 28,
    fill: "white",
    transform: "translate(25 20)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCp);
export default __webpack_public_path__ + "static/media/CP.738a8686adb2dc165844aee80047316e.svg";
export { ForwardRef as ReactComponent };